import { Services } from "./Services";
import BaseClient from "./BaseClient";

const baseURL = Services.PUBLIC_ACCESS.path;

// const baseURL = "http://localhost:4637";

const PublicAccessClient = new BaseClient(baseURL);

export default PublicAccessClient;
